import router from '@/router'
import { getToken } from '@/utils/token.js'
import resourceMap from '@/utils/resource-code'
import { store } from '@/store/store'
import { Message } from 'element-ui'
function getUserAgent () {
  const ua = navigator.userAgent
  const isWindowsPhone = /(?:Windows Phone)/.test(ua)
  const isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone
  const isAndroid = /(?:Android)/.test(ua)
  const isFireFox = /(?:Firefox)/.test(ua)
  const isChrome = /(?:Chrome|CriOS)/.test(ua)
  const isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua))
  const isPhone = /(?:iPhone)/.test(ua) && !isTablet
  const isPc = !isPhone && !isAndroid && !isSymbian
  return {
    isTablet,
    isPhone,
    isAndroid,
    isPc
  }
}
const os = getUserAgent()
const whiteList = [
  'messageCenter',
  // 'topRankingBevol',
  // 'forProducts',
  // 'forClaims',
  // 'forBrand',
  // 'topRankingOtherWebsite',
  // 'topRankingSocialMedia',
  // 'newOldConcepts',
  // 'conceptList',
  // 'oldCconceptList',
  // 'productComparison',
  // 'brandComparison',
  // 'formulationComparison',
  // 'ingredientComparison',
  'formulationNewDesign',
  'formulationPurchase',
  'purchasePurchase',
  'purchase',
  'purchaseDirectly',
  'eLearningList',
  'eLearningDetail',
  // 'eventSpeaker',
  // 'eventFormulationCategory',
  // 'eventFormulation',
  // 'eventProductCategory',
  // 'eventSolution',
  // 'eventProduct',
  'feedback',
  'commentData',
  'otherProductList',
  'otherProductDetail',
  'sourceDetail',
  'comprehensiveSearch',
  'topRrankingSourceIndex',
  'otherWebsiteEditProduct',
  // 'coownerSetting',
  'notFound',
  'noAccess',
  'homePage',
  'registerResult',
  'myProfile',
  'myComments',
  'myFavorites',
  'myRequest',
  'recentlyViewed'
]

const unwantedToken = ['homeoutside', 'registerResult']

// 路由守卫
router.beforeEach(async (to, from, next) => {
  if (to.query.utm_source) {
    sessionStorage.setItem('utm_source', to.query.utm_source)
  }
  // 如果在移动端打开web event详情页，则重定向到h5 event详情页
  if (to.name === 'eventDetail' && (os.isAndroid || os.isPhone)) {
    let baseUrl = ''
    if (process.env.NODE_ENV === 'development') {
      baseUrl = 'http://dlite8.bevol.com/event/index.html?eventId='
    } else if (process.env.NODE_ENV === 'production') {
      baseUrl = 'http://dlite3.basf.com/event/index.html?eventId='
    } else if (process.env.NODE_ENV === 'test') {
      baseUrl = 'http://dlite8.bevol.com/event/index.html?eventId='
    } else if (process.env.NODE_ENV === 'test-pro') {
      baseUrl = 'http://dlite3-test.basf.com/event/index.html?eventId='
    } else if (process.env.NODE_ENV === 'prd') {
      baseUrl = 'http://dlite3.basf.com/event/index.html?eventId='
    }
    const id = to.query.id
    window.location.href = baseUrl + id
    return
  }
  const hasToken = getToken()
  let userInfo = store.getters['login/userInfo']
  let authList = store.getters['login/authList']
  let menuList = store.getters['login/menuList']
  if (!hasToken && !unwantedToken.includes(to.name)) {
    // 没有token，访问系统页面
    localStorage.setItem('Admin-Redirect', to.fullPath)
    next(`/homeoutside?redirect=true`)
  } else if (unwantedToken.includes(to.name)) {
    // 访问登录页面
    next()
  } else {
    // 获取用户信息
    if (JSON.stringify(userInfo) === '{}' || !userInfo) {
      await Promise.all([
        store.dispatch('login/getUserInfoApi'),
        store.dispatch('login/getPermissionApi'),
        store.dispatch('login/getMenuApi')
      ]).then(res => {
        // next(to.fullpath)
      }).catch(e => {
        localStorage.setItem('Admin-Redirect', to.fullPath)
        next(`/homeoutside?redirect=true`)
      })
    }
    if (JSON.stringify(authList) === '{}' || !menuList.length) {
      await Promise.all([
        store.dispatch('login/getUserInfoApi'),
        store.dispatch('login/getPermissionApi'),
        store.dispatch('login/getMenuApi')
      ]).then(res => {
        // next(to.fullpath)
      }).catch(e => {
        localStorage.setItem('Admin-Redirect', to.fullPath)
        next(`/homeoutside?redirect=true`)
      })
    }
    {
      authList = store.getters['login/authList']
      menuList = store.getters['login/menuList']
      const menuAuth = authList.menu
      const pageAuth = authList.page
      const buttonAuth = authList.button
      if (!menuList || !menuList.length) {
        return
      }
      if (whiteList.includes(to.name)) {
        // 白名单
        next()
      } else if (menuAuth.includes(resourceMap[to.name]) || pageAuth.includes(resourceMap[to.name]) || buttonAuth.includes(resourceMap[to.name])) {
        // 权限列表
        next()
      } else {
        // 如果是新开页面，则回首页
        if (!from.name) {
          localStorage.setItem('Admin-Redirect', to.fullPath)
          next(`/homeoutside?redirect=true`)
        } else {
          const lang = localStorage.lang
          const message = lang === 'en'
            ? "Can't view this module, please ask for customer service for more authority"
            : '无此模块权限，如需查看请联系客户服务申请权限'
          Message.error(message)
          // 无权限跳转第一个有权限的页面
          try {
            // const menu = authList.menu
            // const first = menuList.find(v => menu.includes(v.resourceCode))
            // // 成分页面两个tab特殊处理
            // if (first.resourceCode === 'ingredientSelection') {
            //   next(first.url)
            // }
            // if ((first.nodeMenuList && first.nodeMenuList[0] && first.resourceCode !== 'consumerInsights')) {
            //   next(first.nodeMenuList[0].url)
            // } else {
            //   next(first.url)
            // }
            next('/home-page')
          } catch (e) {
          }
          // next('/homeoutside')
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/utils/permission.js